import { FaCode, FaConnectdevelop } from "react-icons/fa";
import { MdOutlineDevices, MdOutlineDevicesOther } from "react-icons/md";
import { TbDeviceDesktopAnalytics } from "react-icons/tb";
import { GrHostMaintenance } from "react-icons/gr";

const servicesData = [
  {
    icon: <FaCode className="text-2xl" />,
    title: "Web & Digital Ecosystems",
    description:
      "We don't just build websites, we build high-performance digital tools designed to scale.",
    imageSrc:
      "https://images.pexels.com/photos/1181216/pexels-photo-1181216.jpeg",
    bgColor: "bg-white",
    backContent: [
      "Custom Web Portals: Dynamic, responsive websites tailored to your brand identity.",
      "Web-Based Tools: Specialized calculators, dashboards, and internal utilities.",
      "E-Commerce & CMS: Robust platforms designed for seamless user journeys and easy content management."
    ],
  },
  {
    icon: <MdOutlineDevices className="text-2xl" />,
    title: "Mobile & Desktop Applications",
    description:
      "Native and cross-platform applications that put your business in the palm of your customer's hand.",
    imageSrc:
      "https://images.pexels.com/photos/34212988/pexels-photo-34212988.jpeg",
    bgColor: "bg-white",
    backContent: [
      "Cross-Platform Apps: High-quality iOS and Android applications.",
      "Desktop Software: Powerful enterprise tools for Windows, macOS, and Linux",
      "Utility Apps: Precision-engineered tools to solve specific operational bottlenecks."
    ],
  },
  {
    icon: <MdOutlineDevicesOther className="text-2xl" />,
    title: "AI & Intelligent Automation",
    description:
      "Future-proof your workflow with custom Artificial Intelligence for smarter decisions.",
    imageSrc:
      "https://images.pexels.com/photos/9783812/pexels-photo-9783812.jpeg",
    bgColor: "bg-white",
    backContent: [
      "Custom AI Agents: Intelligent assistants that handle customer queries or internal data.",
      "Workflow Automation: Reducing human error and manual labor through smart AI scripts.",
      "Predictive Analytics: Using your data to forecast trends and make informed business decisions."
    ],
  },
  {
    icon: <TbDeviceDesktopAnalytics className="text-2xl" />,
    title: "Embedded Systems & IoT Solutions",
    description:
      "Bridging the physical and digital worlds to save you time, effort, and capital.",
    imageSrc:
      "https://images.pexels.com/photos/15555858/pexels-photo-15555858.jpeg",
    bgColor: "bg-white",
    backContent: [
      "Custom Hardware Design: Embedded systems built to your specific requirements.",
      "IoT Integration: Smart sensors and connected devices for real-time monitoring and automation.",
      "Smart Infrastructure: End-to-end IoT setups that optimize resource usage and reduce costs."
    ],
  },
  {
    icon: <FaConnectdevelop className="text-2xl" />,
    title: "Enterprise Resource Planning (ERP)",
    description:
      "Centralize your operations with a single source of truth.",
    imageSrc:
      "https://framerusercontent.com/images/8M5ylKKutuICwnx9s3GURayjYQ.jpg?scale-down-to=2048",
    bgColor: "bg-white",
    backContent: [
      " Industry-Specific ERPs: Tailored modules for manufacturing, retail, and logistics.",
      "Integrated Management: Seamlessly connect HR, Finance, Inventory, and Sales.",
      "Scalable Architecture: Tools that grow alongside your company."
    ],
  },
  {
    icon: <GrHostMaintenance className="text-2xl" />,
    title: "Maintenance & Support",
    description:
      "Reliable post-launch support and maintenance to ensure your digital assets remain secure, fast, and up-to-date.",
    imageSrc:
      "https://framerusercontent.com/images/9KyWAYBvYkUbASCckXa16Fgc.jpg?scale-down-to=512",
    bgColor: "bg-white",
    backContent: [
      "24/7 Monitoring & Uptime",
      "Security Patches & Updates",
      "Performance Optimization",
      "Bug Fixes & Feature Enhancements",
      "Cloud Infrastructure Management",
    ],
  },
];

export default servicesData;
